import type { AuftragLookup } from "@/lib/material";
import { formatAuftragNumberWithYear } from "@/lib/orderDraftUtils";

export function formatAuftragLookupLabel(a: AuftragLookup): string {
  const nummer = formatAuftragNumberWithYear(a);
  return [nummer, a.kunde, a.ort, a.beschreibung].filter(Boolean).join(" · ");
}
